import { defineStore } from "pinia";
import { notify } from "@kyvg/vue3-notification";
import { API_CUPONERA } from "../../helpers/axios";
import { Item } from "../../models/item.models";

export type CatalogosState = {
    busquedaEdos: string;
    dataExample: string;
    arrayEstados: [];
    errorEdos: string;
    mileageArray: any;
    statesArray: any;
    dealerArray: any;
    citiesArray: any;
    statesArrayContact: any;
};

export const useCatalogStore = defineStore({
    id: "example",
    state: (): CatalogosState => ({
        busquedaEdos: "",
        dataExample: "Dato desde el state..",
        arrayEstados: [],
        errorEdos: "",
        mileageArray: [],
        statesArray: [],
        dealerArray: [],
        citiesArray: [],
        statesArrayContact: [],
    }),

    // ACTIONS, Métodos para cambiar el estado
    actions: {
        returnItem(payload: Item) {
            return payload;
        },
        async getMileage(): Promise<void> {
            try {
                const response = await API_CUPONERA(`/mileage/${import.meta.env.VITE_BRAND_ID}`, {
                    method: "GET",
                });
                this.mileageArray = response.data.data.mileages;
            } catch (error) {
                notify({
                    title: "Hubo un error",
                    type: "error",
                    text: "No se pudo obtener el catalogo de Configuración, el dato no existe.",
                });
            }
        },
        async getStates(): Promise<void> {
            try {
                const Response = await API_CUPONERA("/states", { method: "GET" });
                this.statesArray = Response.data.data.states;
                this.statesArrayContact = this.statesArray;
            } catch (error: any) {
                if (error.response.status === 400) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, url o datos desconocidos.",
                    });
                }
                if (error.response.status === 500) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, error en el servicio.",
                    });
                }
            }
        },
        async filterConsecionaria(state_id: string): Promise<void> {
            this.dealerArray = [];
            try {
                const Response = await API_CUPONERA(
                    "/dealers/" + import.meta.env.VITE_BRAND_ID + "/" + state_id,
                    {
                        method: "GET",
                    }
                );
                this.dealerArray = [
                    {
                        dealer_id: "0",
                        name: "Selecciona dealer",
                    },
                    ...Response.data.data.dealers,
                ];
            } catch (error: any) {
                if (error.response.status === 400) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, url o datos desconocidos.",
                    });
                }
                if (error.response.status === 500) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, error en el servicio.",
                    });
                }
            }
        },
        async filterCities(state_id: string): Promise<void> {
            this.citiesArray = [];
            try {
                const Response = await API_CUPONERA("/cities/" + state_id, {
                    method: "GET",
                });
                this.citiesArray = [
                    {
                        city_id: "0",
                        description: "Selecciona una ciudad",
                    },
                    ...Response.data.data.cities,
                ];
            } catch (error: any) {
                if (error.response.status === 400) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, url o datos desconocidos.",
                    });
                }
                if (error.response.status === 500) {
                    notify({
                        title: "Error " + error.response.status,
                        type: "error",
                        text: "No se pudo obtener el listado de Campañas, error en el servicio.",
                    });
                }
            }
        },
    },

    // GETTERS, Los usamos para obtener los valores del estado
    getters: {
        propExample: (state: CatalogosState) => {
            return state.dataExample;
        },
    },
});
